import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Gallery", to: "/gallery" },
  { label: "Public Campaign", to: "/public-campaign" },
  { label: "Contact", to: "/contact" },
];

function AppBarBar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const navigateTo = (path) => {
    setOpen(false);
    navigate(path);
  };

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header className="fixed top-0 inset-x-0 z-50 mt-4">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between rounded-full bg-canvas/90 backdrop-blur border border-forest/10 px-5 py-2.5 shadow-sm">
          <img
            src="media/lg1.png"
            alt="Fighn logo"
            className="w-20 h-auto cursor-pointer"
            onClick={() => navigateTo("/")}
          />

          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-ink/80">
            {navLinks.map((link) => (
              <button
                key={link.to}
                onClick={() => navigateTo(link.to)}
                className="hover:text-forest transition-colors"
              >
                {link.label}
              </button>
            ))}
          </nav>

          <button
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className="md:hidden text-forest p-1"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </div>

      <div
        className={`fixed inset-0 z-50 md:hidden bg-ink transition-opacity duration-300 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="flex flex-col h-full px-8 pt-8 pb-10">
          <div className="flex items-center justify-between">
            <img src="media/lg1.png" alt="Fighn logo" className="w-16 h-auto brightness-0 invert" />
            <button
              aria-label="Close menu"
              onClick={() => setOpen(false)}
              className="text-canvas p-1"
            >
              <X className="w-7 h-7" />
            </button>
          </div>

          <nav className="flex-1 flex flex-col justify-center gap-2">
            {navLinks.map((link, i) => (
              <button
                key={link.to}
                onClick={() => navigateTo(link.to)}
                className={`text-left font-display text-4xl text-canvas/90 hover:text-grain transition-colors py-3 border-b border-canvas/10 transition-transform duration-300 ${
                  open ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
                }`}
                style={{ transitionDelay: open ? `${i * 60}ms` : "0ms" }}
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* <div className="flex gap-4">
            <a
              href="https://x.com/MaterialUI"
              aria-label="Twitter"
              className="w-10 h-10 rounded-full border border-canvas/20 flex items-center justify-center text-canvas hover:bg-canvas/10 transition-colors"
            >
              <Twitter className="w-4 h-4" />
            </a>
            <a
              href="https://www.linkedin.com/company/mui/"
              aria-label="LinkedIn"
              className="w-10 h-10 rounded-full border border-canvas/20 flex items-center justify-center text-canvas hover:bg-canvas/10 transition-colors"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div> */}
        </div>
      </div>
    </header>
  );
}

export default AppBarBar;